import React from "react";
import {Layout} from "antd";
const {Header} = Layout;

export default props => {
    return (
        
        <Header style={{ minHeight: "82px", backgroundColor: "#ffffff", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <img src="https://account-logo.sankhya.com.br/sankhyaid-logo.png" alt="logo do sankhyaID"/>
        </Header>


    )
}
